export default __webpack_public_path__ + "static/media/upRed.5ee82513.svg";